import { EMPTY_CELL } from '@/shared/constants'

import { hasFigure, upTo } from './numberFormat'

/**
 * A number that is neither money nor a percentage — a CPM, a ratio of counts — with a
 * thousands separator and at most `digits` decimals, trailing zeros dropped: `1.23456` at
 * four digits is `1.2346`, `2` is `2`. `null`, `undefined` and `NaN` are `—`, because a
 * figure the backend had no base for is not `0`.
 *
 * Money is `formatMoney` (always two decimals and a currency mark), a `…Percent` field is
 * `formatPercent`.
 */
export function formatDecimal(
  value: number | null | undefined,
  digits = 2
): string {
  if (!hasFigure(value)) return EMPTY_CELL

  return upTo(digits).format(value)
}
